import script from "./BlogCategoriesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogCategoriesList.vue?vue&type=script&setup=true&lang=ts"

import "./BlogCategoriesList.vue?vue&type=style&index=0&id=eaa2883c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaa2883c"]])

export default __exports__